// @ts-nocheck
import { createTheme } from '@mui/material/styles';
import merge from 'lodash/merge';
import baseTheme from './base';

const DARK_THEME = {
  themeName: 'Dark',
  palette: {
    mode: 'dark',
    type: 'dark',
    attributesForm: {
      label: '#DEDEDE',
      value: '#FAFAFA',
    },
    unlink: '#282828',
    menuHover: {
      main: '#47484E',
    },
    primary: {
      main: '#8EABDB', // Brand Blue/30 - Lighter blue for dark mode
      light: '#AEC9F6', // Brand Blue/20
      dark: '#4D6EA6', // Brand Blue/50
      contrastText: '#1D1D1D',
      main1: '#F7F7F7',
    },
    secondary: {
      main: '#F4F4F4', // Grey/40 - Lighter secondary for dark mode
      light: '#F8F8F8', // Grey/20
      dark: '#E9E9E9', // Grey/50
      contrastText: '#1D1D1D',
    },
    selection: {
      main: '#2C508B', // Brand Blue/60
      secondary: '#565656', // Grey/30
      contrastText: '#FFFFFF',
    },
    backdrop: {
      main: 'rgba(0, 0, 0, 0.5)',
    },
    // Brand Blue Scale (from Figma Color Guide - same values, different usage in dark mode)
    blue: {
      5: '#EAF2FF',
      10: '#E5EFFF',
      20: '#AEC9F6',
      30: '#8EABDB',
      40: '#6D8DC0',
      50: '#4D6EA6',
      60: '#2C508B',
      65: '#2B7FFF',
      70: '#0C3270', // Primary Blue
      80: '#0A285A',
      90: '#0A285A',
      100: '#071E43',
      110: '#05142D',
      120: '#020A16',
    },
    kpiCard: {
      pulseIconColor: '#155DFC',
      backgroundColor: '#DBEAFE',
    },
    // Grey Scale (from Figma Color Guide - inverted for dark mode)
    grey: {
      5: '#383D4F',
      10: '#1D1D1D', // T70
      20: '#393939', // T60
      30: '#565656', // T40
      40: '#252730', // Light mode 40
      50: '#E9E9E9', // Light mode 50
      60: '#E4E4E7', // Light mode 60
      70: '#D2D2D2', // Light mode 70
      80: '#BCBCBC', // Light mode 80
      T10: '#8F8F8F',
      T20: '#71717A',
      T30: '#595959',
      T40: '#565656',
      T50: '#535353',
      T60: '#393939',
      T70: '#1D1D1D',
      T80: '#09090B',
    },
    success: {
      10: '#054F31',
      20: '#05603A',
      30: '#027A48',
      40: '#039855',
      50: '#12B76A',
      60: '#32D583',
      main: '#32D583', // Lighter for dark mode (60)
      70: '#12B76A',
      80: '#16A34A',
      90: '#0AA302',
      100: '#039855',
      110: '#027A48',
      120: '#05603A',
      130: '#054F31',
      light: '#6CE9A6',
      dark: '#027A48',
      contrastText: '#1D1D1D',
    },
    error: {
      10: '#7A271A',
      20: '#912018',
      25: '#FAEAEC',
      30: '#B42318',
      40: '#D92D20',
      50: '#F04438',
      main: '#F97066', // Lighter for dark mode (50)
      60: '#F04438',
      70: '#D92D20',
      80: '#B42318',
      90: '#912018',
      100: '#7A271A',
      light: '#FDA29B',
      dark: '#B42318',
      contrastText: '#1D1D1D',
    },
    warning: {
      10: '#7A271A',
      20: '#93370D',
      30: '#B54708',
      40: '#DC6803',
      50: '#F79009',
      main: '#FDB022', // Lighter for dark mode (50)
      60: '#F79009',
      70: '#DC6803',
      80: '#B54708',
      90: '#93370D',
      100: '#7A271A',
      light: '#FEC84B',
      dark: '#B54708',
      contrastText: '#1D1D1D',
    },
    info: {
      main: '#29B6F6', // Light Blue 400 - WCAG AA compliant
      light: '#4FC3F7', // Light Blue 300
      dark: '#0288D1', // Light Blue 700
      contrastText: '#000000', // Black text for better contrast
    },
    lavenderBlue: {
      10: '#F2F2FF',
      20: '#E6E6FF',
      30: '#D6D9FF',
      40: '#C6CCFE',
      50: '#ACB9FD',
      60: '#97A8F8',
      70: '#818EEB',
      80: '#6975D9',
      90: '#4F59C0',
      100: '#3A3F9A',
    },
    // Orange Scale (from Figma Color Guide - same values)
    orange: {
      10: '#FFF6F0',
      20: '#FEE1CD',
      30: '#FCC39C',
      40: '#FBA56A',
      50: '#FA8838',
      60: '#F97316',
      70: '#E56A14',
      80: '#DB6513',
      90: '#CC5E12',
      100: '#8D410C',
    },
    // Sky Blue Scale (from Figma Color Guide - same values)
    skyBlue: {
      5: '#1E2538 ',
      10: '#E2ECFE',
      20: '#CEE0FD',
      25: '#D7EAFE',
      30: '#9DC1FB',
      40: '#6DA2F8',
      50: '#3B82F6',
      60: '#0B64F4',
      70: '#0950C3',
      80: '#073C92',
      90: '#042862',
      100: '#021431',
    },
    background: {
      default: '#1E2028', // Grey/T70
      paper: '#1A1B22', // Grey/T60
      infoBackground: '#2E3037',
      tableHeader: '#34363F',
      default1: '#47484E',
    },
    other: {
      topNavIconColor: '#FFFFFF',
      topNavSelectionBg: 'transparent',
      appHeaderBorder: '#2B2E3D',
      appHeaderNavHover: '#252838',
      appHeaderIconHover: '#252838',
      appHeaderIconColor: '#C8CADE',
      appHeaderShadow:
        '0 4px 16px rgba(0, 0, 0, 0.5), 0 1px 4px rgba(0, 0, 0, 0.3)',
      //  To Do: Below colors are extra, need to remove dependencies of these colors if required
      checkerBackgroundColor: '#1A1B22',
      workflowConnectingEdgeColorDuringConnection: '#FFFFFF',
      workflowEdgeTextColor: ' #FFFFFF',
      activityChartAreaColor: '#F7F7F7',
      reactFlowBackgroundColor: '#1A1B22',
      reactFlowBackgroundLinesColor: '#292C35',
      menuHover: '#353846',
      listTableRowSelectedBg: '#353846',
      badgeBorder: '#EE883D',
      lightBrandBlueLogin: '#84AFEF',
      white: '#FFFFFF',
      overdue: '#E74C3C',
      cell: '#252730',
      gradient1:
        'linear-gradient(90deg, rgba(70, 76, 100, 0.5) 0%, #3D4256 79%)',
      gradient2:
        'linear-gradient(269.82deg, #3D4256 57.25%, rgba(70, 76, 100, 0.1) 230.71%)',
      modelPriorityMedium: '#ffff00',
      statusQueued: '#FF9800',
      successBackgroundColor: '#388E3C',
      errorBackgroundColor: '#D32F2F',
      successCheckIconBackground: '#4CAF50',
      errorCheckIconBackground: '#F44336',
      decisionNodeBgColor: '#9CA8B3',
      decisionNodeLeftSourceHandleBgColor: '#EF4F0B',
      decisionNodeTargetTopHandleBgColor: '#0182FB',
      decisionNodeRightSourceHandleBgColor: '#F7EA00',
      processingNodeBgColor: '#4CAF50',
      processingNodeTopHandleBgColor: '#0182FB',
      processingNodeBottomHandleBgColor: '#F7EA00',
      terminalNodeBgColor: '#FF5722',
      startNodeBgColor: '#ff562262',
      startNodeBottomHandleBgColor: '#EF4F0B',
      nodesBoxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
      borderColor: '#4D4D4D',
      mentionModelTextColor: '#F7F7F7',
      threadTitle: '#F7F7F7',
      threadTagBackground: '#464C64',
      nodeToolBgColor: '#F9F9F9',
      startNodeBackgroundColor: '#C4DBFF',
      endNodeBackgroundColor: '#90EE90',
      startNodeBorderColor: '#3B82F6',
      endNodeBorderColor: '#4CAF50',
      defaultNodeBackgroundColor: '#ffffff',
      currentNodeBackground: '#013661',
      nodeBlackFontColor: '#000000',
      nodeWhiteFontColor: '#ffffff',
      // Table Attribute Schema Builder Colors
      hoverBackground: '#353846',
      editorBackground: '#292C35',
      ruleEditorHover: '#353846',
      toolbarText: '#F7F7F7',
      editorHeaderText: '#FFFFFF',
      editorResizeHandle: '#CACACA',
      addIconColor: '#F7F7F7',
      // Adding editor-related colors
      editorBorder: '#C7C7C7',
      danger: '#F44336',
      lightText: '#FFFFFF',
      inputBackground: '#252730',
      // Shadow colors with transparency
      shadowLight: 'rgba(0, 0, 0, 0.4)',
      shadowLighter: 'rgba(0, 0, 0, 0.3)',
      // AppBar and other colors
      appBar: '#1E2028',
      sidebar: '#292C35',
      sidebarMenuHover: '#353846',
      sidebarMenuSelected: '#3D4256',
      outlineColor: '#FFFF',
      AttributeCardColor: 'rgba(199, 199, 199, 0.4)',
      MasterFilterHeadBackgroundColor: '#3D4256',
      MasterFilterFontColor: '#E8F0FE',
      MasterFilterHoverBackgroundColor: '#3D4256',
      deleteIconBackgroundHomePageSetup: '#353846',
      calculationBgColor: '#1A1B22',
      calculateBorderColor: '#999999',
      infoBoxColor: '#2E3037',
      attachmentBorder: '#E3E6F0',
      // AI Autofill feature colors
      aiPrimary: '#6633D9',
      aiPrimaryDark: '#7040D4',
      aiPrimaryLight: '#B388FC',
      aiPrimaryBg: '#5B408D',
      aiHighlightShadowBase: 'rgba(142, 85, 249, 0.25)',
      aiHighlightShadowStrong: 'rgba(142, 85, 249, 0.35)',
      aiHighlightShadowMedium: 'rgba(142, 85, 249, 0.30)',
      aiHighlightShadowSoft: 'rgba(142, 85, 249, 0.20)',
      aiHighlightBackgroundBase: 'rgba(142, 85, 249, 0.08)',
      aiHighlightBackgroundSubtle: 'rgba(142, 85, 249, 0.05)',
      aiHighlightBackgroundStrong: 'rgba(142, 85, 249, 0.12)',
      aiHighlightBackgroundMedium: 'rgba(142, 85, 249, 0.10)',
      aiHighlightBackgroundSoft: 'rgba(142, 85, 249, 0.06)',
      aiHighlightBackgroundFaint: 'rgba(142, 85, 249, 0.02)',
      aiPrimaryText: '#FFFFFF',
      aiPrimaryButtonText: '#FFFFFF',
      badgeBg: '#353846',
      badgeText: '#FFFFFF',
      brandBlue: '#0C3270',
      jobCountBG: '#707177',
      jobCount: '#F7F7F7',
      filterDrawerBackground: '#252730',
      filterCardStroke: '#30323D',
      filterCardFill: '#252730',
      filterCardHover: '#47484E',
      filterCardActiveFill: '#47484E',
      filterResetBorder: '#8E55F9',
      filterTabsBorder: '#30323D',
      filterTabsBackground: '#1E2028',
    },
    examinationResults: {
      guidelineIconBg: 'rgba(255, 183, 77, 0.08)',
      confidenceGreen: '#81C784',
      confidenceAmber: '#FFB74D',
      severityCritical: '#EF9A9A',
      severityHigh: '#FFCC80',
      severityMedium: '#FFB74D',
      severityLow: '#80CBC4',
      overallStrong: '#81C784',
      overallMedium: '#FFB74D',
      overallWeak: '#EF9A9A',
      verdictReady: '#81C784',
      verdictNotReady: '#EF9A9A',
      sidebarActiveBg: '#464C64',
      sidebarInactiveBg: '#1E2028',
      sidebarText: '#FFFFFF',
      categoryBadgeBg: '#353846',
      categoryBadgeText: '#FFFFFF',
      border: '#4D4D4D',
      severityCriticalBg: '#4A2323',
      severityHighBg: '#4B3823',
      severityMediumBg: '#4A3B1F',
      severityLowBg: '#1F3D3A',
      ratingStrongBg: '#1B3A1F',
      ratingMediumBg: '#4A3B1F',
      ratingWeakBg: '#4A2323',
      verdictReadyBg: '#1B3A1F',
      verdictNotReadyBg: '#4A2323',
      findingsIconBg: '#E0F2FE',
      findingsIconColor: '#075985',
    },
    draft: {
      // Draft field accent colors
      accent: '#FDB022',
      border: '#F59E0B',
      rowBg: '#241C00',
      inputBg: '#2A1E00',
      iconColor: '#9E9E9E',
      // Draft editor avatar colors (per-user colors in co-editing)
      editorAvatarColor0: '#00897B',
      editorAvatarColor1: '#FB8C00',
      editorAvatarColor2: '#8E24AA',
      // History drawer avatar backgrounds
      historyAvatarBg0: '#4D6EA6',
      historyAvatarBg1: '#006E28',
      historyAvatarBg2: '#F59E0B',
      // History drawer timeline nodes
      historyTimelineActive: '#5B8BFF',
      historyTimelineInactive: '#757575',
      // History drawer diff chip backgrounds
      historyDiffAddedBg: '#0A3320',
      historyDiffEditedBg: '#3A2A0A',
      historyDiffEditedColor: '#FDB022',
      historyDiffRemovedBg: '#3A1515',
      historyDiffRemovedColor: '#F97066',
    },
    dynamicBarChart: {
      barColor: '#ACB9FD',
      textColor: '#F7F7F7',
      gridLineColor: '#CCCCCC',
    },
    landScapeLegendOtherColors: {
      legend1: '#EE9023',
      legend2: '#ACB9FD',
      legend3: '#F4B2B6',
      legend4: '#F9BCE4',
      legend5: '#EBF0B1',
      legend6: '#D4BCF2',
      legend7: '#DEF0B8',
      legend8: '#B3F0F0',
      legend9: '#645FE4',
    },
    landscape: {
      mainNode: '#4A4C5AFF',
      model: '#0C3270',
      artifact: '#05603A',
      useCase: '#D96144',
      assessment: '#F79009',
      attribute: '#DA70D6',
      query: '#4F39F6',
      bg: {
        main: '#353846',
        model: '#AEC9F6',
        artifact: '#D1FADF',
        useCase: '#FEE4E2',
        query: '#C8C1FF',
        assessment: '#FEF0C7',
        attribute: '#AEAEAE',
        accessRequest: '#E5EFFF',
      },
      // ReactFlow node handles and default edge stroke
      handleColor: '#C1C1C1',
      // Selected item background in cluster-node entity dropdown (dark mode)
      menuItemSelected: '#3A3D4A',
      // Muted icon color (e.g. linked_entity_count icon, dark mode)
      iconMuted: '#888888',
      // Relation tooltip label color
      tooltipLabelColor: '#8A96AB',
      // Entity cluster-node menu item hover / selected background (dark mode)
      entityMenuItemHover: '#3A3D4A',
      // Lineage node handle color (primary.main at 60% opacity, dark mode)
      lineageHandleColor: 'rgba(142, 171, 219, 0.6)',
      // Deterministic dot colors for cluster nodes in the landscape view
      nodeDotColors: [
        '#4C9BE8',
        '#F59E0B',
        '#10B981',
        '#8B5CF6',
        '#EF4444',
        '#06B6D4',
        '#F97316',
        '#84CC16',
        '#EC4899',
        '#6366F1',
      ],
    },
    entityTypeEditor: {
      cardBackground: '#292C35',
      cardBorder: '#464C64',
      cardDivider: '#353846',
      previewBorder: '#464C64',
      previewBackground: '#1A1B22',
      dropzoneBorder: '#464C64',
      dropzoneHoverBackground: '#353846',
      layoutButtonBackground: '#1A1B22',
      layoutButtonSelectedBackground: '#464C64',
      tabIndicator: '#FFFFFF',
      predefinedIconBackground: '#35533A',
      predefinedIconColor: '#A7F3C1',
    },
    summaryCardQueryColors: {
      open: '#DBEAFE',
      AcknowlegeQuery: '#F3E8FF',
      inReview: '#FFE2E2',
      closed: '#DCFCE7',
    },
    queryStatus: {
      open: '#175CD3',
      draftResponse: '#344054',
      draft: '#344054',
      waive: '#0A5E2A',
      revisionRequested: '#5B2C91',
      closed: '#FFFFFF',
      responseReceived: '#8B2C00',
      inReview: '#003366',
      bg: {
        open: '#175CD3',
        draftResponse: '#344054',
        draft: '#344054',
        waive: '#0A5E2A',
        revisionRequested: '#5B2C91',
        responseReceived: '#8B2C00',
        closed: '#16A34A',
        inReview: '#003366',
      },
    },
    actionsQueryStatus: {
      act: '#393939',
      actButton: '#282E52',
      border: '#292C56',
    },
    queryFilter: {
      color: '#09090B',
      bgcolor: '#FFFFFF',
    },
    queryDialog: {
      title: '#F7F7F7',
      subtitle: '#C8CADE',
      closeIcon: '#98A2B3',
      panelBackground: '#252730',
      panelBorder: '#3D4256',
      inputBackground: '#1A1B22',
      actionBorder: '#E8F0FE',
      bannerBg: '#1E2538',
      bannerBorder: '#464C64',
      accordionHeaderBg: '#252730',
      accordionHeaderBorder: '#3D4256',
      ChangeStatus: '#515FA7',
    },
    queryTitle: {
      color: '#2E2E2E',
    },
    historyTimeLine: {
      line: '#272D55',
      updatedText: '#CACACA',
      activeDot: '#1976D2',
      inactiveDot: '#848484',
      objectKey: '#CACACA',
      objecetVal: '#F8F8F8',
    },
    actionable: {
      actionableNodeBg: '#2A2A2A',
      actionableNodeBorder: '#4A4A4A',
      actionableNodeText: '#AAAAAA',
      actionableNodeDotBg: '#AAAAAA',
      actionableSelectedNodeBg: '#1A2C4E',
      actionableSelectedNodeBorder: '#4A86E8',
      actionableSelectedNodeText: '#A8C8FF',
      actionableDetailsLabelText: '#CACACA',
      actionableDetailsItemBorder: '#464C64',
      actionableDetailsItemPathText: '#CACACA',
    },
    mentionsInChatEntityColor: {
      attributeNode: '#81C784',
      model: '#E57373',
      artifact: '#F7F7F7',
      document: '#FFB74D',
      userName: '#CACACA',
      hoverTextColor: '#000000',
      background: '#464C64',
      textColor: '#FFFFFF',
    },
    draftjsPopover: {
      mentionSuggestions: {
        borderColor: '#4D4D4D',
        backgroundColor: '#353846',
      },
      mentionSuggestionsEntryFocused: {
        backgroundColor: '#464c6480',
      },
    },
    text: {
      primary: '#CACACA', // Grey/20 (light mode)
      secondary: '#F8F8F8', // Grey/50 (light mode)
      disabled: '#8F8F8F', // Grey/T10
      contrastText: '#1A1A1A',
      placeholder: 'rgba(255, 255, 255, 0.87)', // For input placeholders
      hint: 'rgba(255, 255, 255, 0.87)', // For hint text
      inactiveTab: 'rgba(255, 255, 255, 0.7)', // For inactive tabs
      // To Do: Below colors are extra, need to remove dependencies of these colors if required
      light: '#FFFFFF',
      light1: '#CACACA',
      dark: '#FFFFFF',
      manual: '#29B6F6',
      automation: '#4CAF50',
      calculated: '#CE93D8',
      overridden: '#C3000D',
      default: '#FFFFFF',
      toolbarOption: '#CACACA',
      cardCountText: '#1E2028',
    },
    divider: '#344054', // Grey/T40
    contextMenu: {
      menu: {
        '--contexify-menu-bgColor': '#1A1B22',
        '--contexify-item-color': '#FFFFFF',
        '--contexify-activeItem-bgColor': '#353846',
        '--contexify-activeItem-color': '#FFFFFF',
        '--contexify-arrow-color': '#A0AEC0',
        '--contexify-activeArrow-color': '#F7F7F7',
        '--contexify-rightSlot-color': '#A0AEC0',
        '--contexify-activeRightSlot-color': '#FFFFFF',
        '--contexify-separator-color': '#344054',
      },
    },
    compareVersion: {
      added: {
        bgColor: '#e8f5e9',
        borderColor: '#a5d6a7',
      },
      removed: {
        bgColor: '#ffebee',
        borderColor: '#ef9a9a',
      },
      modified: {
        bgColor: '#fff8e1',
        borderColor: '#ffe082',
      },
      versionHeader: '#464c6466',
    },
    notificationBanner: {
      background: '#353846',
    },
    documentLinkedEntities: {
      titleText: '#FFFFFF',
      warningBackground: '#353846',
      borderColor: '#4D4D4D',
    },
    layout: {
      backgroundColor: '#13141A',
    },
    transitionHistoryStatusColors: {
      success: '#4CAF50',
      failed: '#F44336',
      partiallySuccessful: '#FF9800',
      default: '#FFFFFF',
    },
    entityColor: {
      model: '#E57373',
      artifact: '#F7F7F7',
      artifactLandscapeView: '#FFFFFF',
      assessment: '#81C784',
      useCase: '#4FC3F7',
      accessRequest: '#F7F7F7',
      query: '#4F39F6',
      globalAttributes: '#464C64',
      background: {
        model: '#D32F2F',
        artifact: '#3D4256',
        assessment: '#388E3C',
        useCase: '#0288D1',
        accessRequest: '#3D4256',
        globalAttributes: '#292C35',
      },
      artifactSubColor: {
        level1: '#966E2F',
        level2: '#F39C12',
        level3: '#F78C6B',
        default: '#272D55',
      },
    },
    sseNotification: {
      successIconColor: '#4CAF50',
      partialIconColor: '#FF9800',
      failedIconColor: '#F44336',
      pendingIconColor: '#7D7D7D',
    },
    aiAutofillNotification: {
      inProgressHeaderBg: '#3A1F6E',
      completedHeaderBg: '#1B5E20',
      failedHeaderBg: '#B71C1C',
      headerTextColor: '#FFFFFF',
      bodyBg: '#292C35',
      subtitleColor: '#9E9E9E',
      progressTrackColor: '#464C64',
      progressBarColor: '#B388FC',
      inProgressIconBg: '#2A1F4E',
      completedIconBg: '#1B3A1F',
      failedIconBg: '#3B1A1A',
      inProgressIconColor: '#B388FC',
      completedIconColor: '#66BB6A',
      failedIconColor: '#EF5350',
      viewSuggestionsButtonBg: '#8E55F9',
      viewSuggestionsButtonHoverBg: '#7040D4',
    },
    AINotification: {
      inProgressHeaderBg: '#8E55F9',
      completedHeaderBg: '#1B5E20',
      failedHeaderBg: '#B71C1C',
      headerTextColor: '#FFFFFF',
      bodyBg: '#292C35',
      subtitleColor: '#9E9E9E',
      progressTrackColor: '#464C64',
      progressBarColor: '#8B96DE',
      inProgressIconBg: '#353846',
      completedIconBg: '#1B3A1F',
      failedIconBg: '#3B1A1A',
      inProgressIconColor: '#AECDFC',
      completedIconColor: '#66BB6A',
      failedIconColor: '#EF5350',
    },
    regulatoryMapper: {
      warningMain: '#FFB547',
      warningBg: '#3A2800',
    },
    monacoEditor: {
      colors: {
        'editor.foreground': '#FFFFFF',
        'editor.background': '#1A1B22',
        'editorCursor.foreground': '#F7F7F7',
        'editor.lineHighlightBackground': '#292C35',
        'editorLineNumber.foreground': '#464C6480',
        'editorLineNumber.activeForeground': '#F7F7F7',
        'editor.selectionBackground': '#464C6450',
        'editor.inactiveSelectionBackground': '#464C6430',
        'editorGutter.background': '#292C35',
        'scrollbarSlider.background': '#464C6480',
        'scrollbarSlider.hoverBackground': '#8B96DE80',
        'scrollbarSlider.activeBackground': '#F7F7F780',
      },
      derivedFormulaEditor: {
        colors: {
          'editor.background': '#1E1E1E',
          'editorLineNumber.foreground': '#5A5A5A',
          'editorCursor.foreground': '#FFFFFF',
          'editor.foreground': '#C9D1D9',
          'editor.lineHighlightBackground': '#2A2A2A',
          'editor.selectionBackground': '#264F78',
          'editor.inactiveSelectionBackground': '#3A3D41',
          'editorGutter.background': '#232323',
          'scrollbarSlider.background': '#42424280',
          'scrollbarSlider.hoverBackground': '#5A5A5A80',
          'scrollbarSlider.activeBackground': '#C9D1D980',
          'editorGhostText.foreground': '#FFFFFF87',
        },
        tokenColors: {
          'formula-block': '#FFB300',
          comment: '#7F848E',
          string: '#A3E635',
          keyword: '#82AAFF',
          number: '#F78C6B',
          variable: '#FFD700',
          identifier: '#E0E0E0',
        },
      },
    },
    // ColorPicker palette colors
    colorPicker: {
      black: '#000000',
      darkGray: '#434343',
      mediumGray: '#666666',
      gray: '#999999',
      lightGray: '#b7b7b7',
      lighterGray: '#cccccc',
      lightestGray: '#d9d9d9',
      nearWhite: '#efefef',
      offWhite: '#f3f3f3',
      white: '#ffffff',
      darkRed: '#980000',
      red: '#ff0000',
      orange: '#ff9900',
      yellow: '#ffff00',
      green: '#00ff00',
      cyan: '#00ffff',
      blue: '#4a86e8',
      brightBlue: '#0000ff',
      purple: '#9900ff',
      magenta: '#ff00ff',
    },
    lifeCycleWorkflow: {
      workflowActiveNodeBg: '#F7F7F7',
      workflowActiveNodeText: '#3B3B3B',
      workflowNodeBorder: '#F7F7F7',
      highlightedEdgeColor: '#F7F7F7',
      edgeTextColor: '#F7F7F7',
      highlightedEdgeBackground: '#464C64',
      completedNodeBg: '#166534',
      completedNodeBorder: '#16A34A',
      completedNodeText: '#DCFCE7',
      currentNodeBg: '#9A3412',
      currentNodeBorder: '#F97316',
      currentNodeText: '#FFEDD5',
      pendingNodeBg: '#374151',
      pendingNodeBorder: '#6B7280',
      pendingNodeText: '#E5E7EB',
    },
    // Workflow Editor — Node & Edge tokens (dark mode)
    workflow: {
      node: {
        defaultBg: '#393939',
        defaultBorder: '#565656',
        defaultText: '#F8F8F8',
        startBg: '#0A285A',
        startBorder: '#4D6EA6',
        startText: '#AEC9F6',
        endBg: '#912018',
        endBorder: '#D92D20',
        endText: '#FDA29B',
        conditionalBg: '#0A285A',
        conditionalBorder: '#4D6EA6',
        conditionalText: '#AEC9F6',
        groupBg: 'rgba(10, 40, 90, 0.35)',
        groupBorder: '#4D6EA6',
        groupText: '#AEC9F6',
        handleColor: '#8F8F8F',
      },
      edge: {
        defaultStroke: '#F8F8F8',
        conditionalStroke: '#F97066',
        labelColor: '#E9E9E9',
      },
      canvas: {
        dotColor: '#565656',
        minimapBorder: '#565656',
      },
    },
    workflowGroups: {
      complete: '#16A34A',
      ongoing: '#3B82F6',
      pending: '#F97316',
      groupNodeBg: '#383941',
    },
    loginPage: {
      background: '#1A1B22',
      loginFormBorder: '#E5E7EB',
    },
    advanceFilters: {
      combinatorButtonBackgroundColorAdvTab: '#1B1B1B',
      selectedCombinatorButtonBackgroundColorAdvTab: '#535252',
      selectedHoverFieldBackground: '#E8F0FE',
      advanceBlockHeaderColor: '#BCBCBC',
      combinatorTextColor: '#555555',
      defaultTextColor: '#FFFFFF',
      countBackgroundColor: '#F0F0F0',
      buttonBorderColor: '#BCBCBC',
      borderRightBasicTab: '#E9E9E9',
      selectedLeftFieldBackground: '#636363',
      hoverLeftFieldBackground: '#F9F9F9',
      iconHoverColor: '#F0F0F0',
      andOrBoxShadow: 'rgba(255, 255, 255, 1)',
      groupBorder: '#69696D',
      iconColor: '#FFFFFF',
      textColor: '#000000',
      whiteTextColor: '#FFFFFF',
      hoveringCountBackgroundColor: '#0C3270',
    },
    // Log Filter
    logFilters: {
      linkColor: '#E0E0E0',
      borderColor: '#E0E0E0',
      LogModuleBackgroundColor: '#353846',
      fontColor: '#FFFFFF',
    },
    archivedBanner: {
      fontColor: '#282828',
      iconColor: '#272D55',
      bannerBackgroundColor: '#FFF8E1',
      bannerBorderColor: '#FFE082',
    },
    tableWrapper: {
      backgroundColor: '#1E2028',
      borderColor: '#344054',
      headerBorderColor: 'E3E6F0',
    },
    uploadProgress: {
      success: '#4CAF50',
      headerTitle: '#F7F7F7',
      headerBg: '#292C35',
      border: '#4D4D4D',
      progressWheelBackground: '#FFFFFF1A',
      boxShadow: '0px 8px 24px #FFFFFF26',
    },
    //Entity Overview
    entityOverview: {
      accordionExpand: '#3d434b',
      accordionCollapse: '#1A1B22',
      accordionSelected: '#383941',
      borderLfetTightPanel: '#E0E0E0',
      IconColor: '#FFFFFF',
      accordionTitleBackground: '#1E2028',
      dividerBorder: '#CACACA',
      headerText: '#FFFFFF',
    },
    vaultChat: {
      color: '#A4A4A4',
    },
    actionablesColor: {
      background: {
        high: '#4A2326',
        medium: '#4A3A1E',
        low: '#1B315F',
        completed: '#173A2D',
      },
      iconColor: '#FFFFFF',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '*': {
          '&::-webkit-scrollbar-thumb': {
            background: '#CACACA',
          },
          '&:hover::-webkit-scrollbar-thumb': {
            backgroundColor: '#FFF8E1',
          },
        },
        '.hover-scrollbar.is-visible::-webkit-scrollbar-thumb': {
          background: '#CACACA',
        },
        '@keyframes linkedEntityBtnPulse': {
          '50%': {
            boxShadow: '0 0 14px 4px #DC6803',
          },
        },
        '.contexify': {
          boxShadow: `0px 4px 16px rgba(0, 0, 0, 0.5)`,
          border: '1px solid #344054',
        },
        '.contexify_itemContent': {
          color: 'var(--contexify-item-color, #FFFFFF)',
        },
        // React Query Builder specific styles for dark theme
        '.ruleGroup': {
          borderColor: '#CACACA !important',
          backgroundColor: '#1A1B22 !important',
        },
        '.rule': {
          backgroundColor: `rgba(70, 76, 100, 0.4) !important`,
          borderLeftColor: '#F7F7F7 !important',
        },
        '.ruleGroup .rule': {
          backgroundColor: '#1A1B22 !important',
        },
        '.ruleGroup .rule-value': { backgroundColor: '#1A1B22 !important' },
        '.ruleGroup .rule-fields': { backgroundColor: '#1A1B22 !important' },
        '.ruleGroup .rule-operators': { backgroundColor: '#1A1B22 !important' },
        '.ruleGroup .ruleGroup-body': { backgroundColor: '#1A1B22 !important' },
        '.custom-link:focus-visible': {
          outline: '2px solid #F7F7F7',
        },
        '.table-card-wrapper': {
          backgroundColor: '#1E2028',
          border: '1px solid #344054',
        },
        '.query-dialog-form-container': {
          backgroundColor: '#252730',
          border: '1px solid #3D4256',
          borderRadius: '12px',
          padding: '20px 16px',
          '@media (min-width: 900px)': {
            paddingLeft: '20px',
            paddingRight: '20px',
          },
          '& .MuiOutlinedInput-root': {
            backgroundColor: '#1A1B22',
            borderRadius: '6px',
          },
          '& .summary-card': {
            backgroundColor: 'transparent !important',
            borderRadius: '0 !important',
            padding: '0 !important',
            boxShadow: 'none !important',
            margin: '0 -8px !important',
            width: 'calc(100% + 16px) !important',
            maxWidth: 'calc(100% + 16px) !important',
          },
          '& .MuiFormHelperText-root': {
            marginLeft: 0,
            marginTop: '6px',
          },
        },
        '.ai-autofill-notification': {
          '& .title': {
            color: '#FFFFFF',
          },
          '& .title.in-progress': {
            backgroundColor: '#3A1F6E',
          },
          '& .title.completed': {
            backgroundColor: '#1B5E20',
          },
          '& .title.failed': {
            backgroundColor: '#B71C1C',
          },
          '& .body': {
            backgroundColor: '#292C35',
          },
          '& .actions': {
            backgroundColor: '#292C35',
          },
          '& .subtitle': {
            color: '#9E9E9E',
          },
          '& .icon.in-progress': {
            backgroundColor: '#2A1F4E',
            color: '#B388FC',
          },
          '& .icon.completed': {
            backgroundColor: '#1B3A1F',
            color: '#66BB6A',
          },
          '& .icon.failed': {
            backgroundColor: '#3B1A1A',
            color: '#EF5350',
          },
          '& .progress': {
            backgroundColor: '#464C64',
          },
          '& .progress .MuiLinearProgress-bar': {
            backgroundColor: '#B388FC',
          },
          '& .dismiss': {
            color: '#FFFFFF',
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.16)',
            },
          },
          '& .actions .action.in-progress': {
            borderColor: '#B388FC',
            color: '#B388FC',
          },
          '& .actions .action.view-suggestions': {
            backgroundColor: '#8E55F9',
            color: '#FFFFFF',
            '&:hover': {
              backgroundColor: '#7040D4',
            },
          },
          '& .actions .action.retry': {
            backgroundColor: '#F44336',
            color: '#FFFFFF',
            '&:hover': {
              backgroundColor: '#D32F2F',
            },
          },
        },
        '&:hover .leftFieldCount': {
          backgroundColor: '#E8F0FE',
          color: '#000000',
        },
        '&:hover .leftFieldIcon': {
          color: '#E8F0FE',
        },
        '.conditional-query-builder': {
          '& .conditionalRuleGroup': {
            backgroundColor: 'transparent !important',
          },
        },
        html: {
          // Table resizer styles
          '& .resizer': {
            backgroundColor: 'transparent !important',
            color: '#464C64',
            '&.isResizing': {
              color: '#8B96DE',
            },
          },
        },
        '.editor-toolbar': {
          display: 'flex',
          alignItems: 'start',
          minHeight: '40px',
        },
        // tip tap editor styles
        ':root': {},
        '.tiptap pre': {
          background: '#1A1B22',
          color: '#F7F7F7',
        },
        '.tiptap code': {
          backgroundColor: '#292C35',
          color: '#FFFFFF',
        },
        '.tiptap blockquote': {
          borderLeft: '3px solid #8B96DE',
        },

        '.dark-theme .mdxeditor-toolbar button[data-toolbar-item="true"]': {
          backgroundColor: '#292C35 !important',
          color: '#F7F7F7 !important',
          border: '1px solid #292C35 !important',
        },
        '.dark-theme .mdxeditor-toolbar button[data-toolbar-item="true"]:hover':
          {
            backgroundColor: '#464C64 !important',
          },
        // Dropdown content
        '.dark-theme .mdxeditor-select-content': {
          backgroundColor: '#292C35 !important',
          border: '1px solid #464C64 !important',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.5) !important',
        },
        '.dark-theme .mdxeditor-select-content .mdxeditor-select-viewport': {
          backgroundColor: '#292C35 !important',
        },
        // Dropdown items
        '.dark-theme .mdxeditor-select-item': {
          backgroundColor: '#292C35 !important',
          color: '#F7F7F7 !important',
          padding: '8px 12px !important',
        },
        '.dark-theme .mdxeditor-select-item[data-highlighted]': {
          backgroundColor: '#464C64 !important',
          color: '#FFFFFF !important',
          outline: 'none !important',
        },
        'body:has(.dark-theme) .mdxeditor-popup-container .mdxeditor-select-content':
          {
            backgroundColor: '#292C35 !important',
            border: '1px solid #464C64 !important',
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.5) !important',
          },
        'body:has(.dark-theme) .mdxeditor-popup-container .mdxeditor-select-item':
          {
            backgroundColor: '#292C35 !important',
            color: '#F7F7F7 !important',
          },
        'body:has(.dark-theme) .mdxeditor-popup-container .mdxeditor-select-item[data-highlighted]':
          {
            backgroundColor: '#464C64 !important',
            color: '#FFFFFF !important',
          },

        '.tiptap hr': {
          borderTop: '1px solid #8B96DE',
        },
        '.tiptap img.ProseMirror-selectednode': {
          outline: '3px solid #464C64',
        },
        '.tiptap td, .tiptap th': {
          border: '1px solid #CACACA',
        },
        '.tiptap th': {
          backgroundColor: '#292C35',
        },
        '.tiptap .selectedCell::after': {
          background: '#464C6420',
        },
        '.tiptap .column-resize-handle': {
          backgroundColor: '#464C64',
        },
        '.tiptap table[data-border="hidden"] td': {
          border: 'none',
        },
        '.tiptap table[data-border="hidden"] th': {
          border: 'none',
        },
        '.tiptap p.is-editor-empty:first-child::before': {
          color: '#CACACA',
        },
        // Table schema resize handler styles
        '.resize-handle::after': {
          borderColor: '#F7F7F7 !important',
        },
        '.resize-handle:hover': {
          backgroundColor: 'rgba(247, 247, 247, 0.4)',
        },
        '.resize-handle:active': {
          backgroundColor: 'rgba(247, 247, 247, 0.4)',
        },
        '.account-id-form': {
          backgroundColor: '#1A1B22',
        },
        '.login-form': {
          backgroundColor: '#1A1B22',
        },
        // RichEditor specific styles
        '& .RichEditor-editor .RichEditor-blockquote': {
          borderLeft: `5px solid #353846`,
          color: '#CACACA',
        },
        '& .RichEditor-editor .public-DraftStyleDefault-pre': {
          backgroundColor: '#292C35',
        },

        '& .RichEditor-styleButton': {
          color: '#CACACA',
        },
        '& .RichEditor-activeButton': {
          color: '#F7F7F7',
        },
        '.RichEditorOuterBox': {
          '&.read-only': {
            border: 'none',
          },
          '&.edit-only': {
            border: '1px solid #464C64',
          },
        },

        // statusPlaning
        '.statusTaskCardColumn': {
          backgroundColor: '#1A1B22',
          border: '1px solid #344054',
        },
        '.statusPlanningTemplateDetails': {
          backgroundColor: '#1A1B22',
        },
        '.statusTaskCardColumnHeader': {
          backgroundColor: '#34363F',
        },
        '.statusTaskCardColumnHeaderText': {
          color: '#FAFAFA',
        },
        '.statusTaskCardLabel': {
          fontFamily: 'inter',
          color: '#616E85',
        },
        '.statusTaskCard': {
          background: '#292C35',
          border: '0.5px solid #D6D6D6',
          boxShadow: `0px 0.8px 1.8px 0px ${'rgba(0, 0, 0, 0.4)'},0px 0.15px 0.45px 0px ${'rgba(0, 0, 0, 0.3)'}`,
          '&:hover': {
            background: '#353846',
          },
        },
        '.statusTaskCardAvatar': {
          backgroundColor: '#F8EACD !important',
          color: '#7E5C0A !important',
        },

        //ReportCategory Table Accordian
        '.tableAccordionChip': {
          backgroundColor: '#34363F !important',
          color: '#000000 !important',
        },

        '.tableAccordionList': {
          borderColor: '#8F8F8F !important',
        },

        // Bulk actions
        '.bulk-container': {
          border: '1px solid #F7F7F7',
          background: '#1A1B22',
        },

        // Remove problematic global override for FilterIcon
        // Previously: '.FilterIcon svg': { color: '#FFFFFF !important' },
        // This override is intentionally omitted to allow correct icon color from theme or inline style.
        // Document template upload
        '.dropzone': {
          border: '1px dashed #F7F7F7',
          background: '#1A1B22',
        },
        '.dropzone-error': {
          border: '2px dashed #F44336',
          background: '#1A1B22',
        },
        // Help and support article card
        '.help-support-article-card': {
          ':hover': {
            backgroundColor: 'rgba(70, 76, 100, 0.4)',
            borderColor: '#F7F7F7',
          },
        },
        '.renderRowSubComponent': {
          backgroundColor: '#1A1B22',
          '&.MuiTableRow-root': {
            backgroundColor: '#1A1B22 !important', // Added !important
            '&:hover': {
              backgroundColor: '#1A1B22 !important', // Added hover background color
            },
          },
        },
        // Theme and appearance
        '.uploadedLogoPreview': {
          border: `1px dashed #F7F7F7 !important`,
          borderRadius: '4px',
          backgroundColor: '#292C35',
        },
        '.logoDropzone': {
          border: `1px dashed #CACACA`,
          backgroundColor: '#1A1B22',
          outline: 'none',
          '&:focus': {
            borderColor: '#F7F7F7',
          },
          '&.text': {
            color: '#CACACA',
          },
        },
        // Upload document attribute sharepoint
        '.upload-document-attribute': {
          border: `2px dashed #F7F7F7`,
        },
        // Alerts drawer list
        '.alert-drawer-list': {
          '&:hover': {
            background: '#353846',
          },
          '&:focus-visible': {
            background: '#353846',
          },
        },
        // Approval list
        '.approval-list': {
          '&:hover': {
            background: '#353846',
          },
          '&:focus-visible': {
            background: '#353846',
          },
        },
        //  Permission Buttons
        '.permissionButtons': {
          '&.active': {
            color: '#F7F7F7',
          },
          '&.inactive': {
            color: '#838383',
          },
        },
        '.disabledTextColor': {
          color: '#FFFFFF99',
        },
        '.infoTextStyle': {
          color: '#0288D1',
        },
        // Automation
        '.automation-action-component, .automation-trigger-component, .automation-condition-component, .automation-loop-component':
          {
            borderColor: '#F7F7F7',
            backgroundColor: '#292C35',
            color: '#CACACA',
            '&.active, &:hover': {
              backgroundColor: 'rgba(70, 76, 100, 0.4)',
            },
          },
        '.automation-action-component.is-dragging': {
          backgroundColor: '#565656',
        },
        '.automation-node-icon': {
          backgroundColor: '#0C3270',
          color: '#FFFFFF',
        },
        '.automation-node-title': {
          color: '#F7F7F7',
        },
        '.automation-node-description, .automation-node-icon-button': {
          color: '#F8F8F8',
        },
        // chatbot
        '.citationBox': {
          backgroundColor: '#292C35',
          '&.text': {
            color: '#FFFFFF',
          },
        },
        '.messageBox': {
          '&.isUser': {
            backgroundColor: '#353846',
          },
          '&.error': {
            backgroundColor: '#F44336',
          },
          '&.other': {
            backgroundColor: '#292C35',
          },
        },

        '.typeFilterChip': {
          backgroundColor: '#292C35',
          '&.isOpen': {
            backgroundColor: '#464C64',
          },
          '&:focus-visible': {
            outline: `2px solid #F7F7F7`,
          },
        },
        '.logFilterChip, .MuiButtonBase-root.logFilterChip': {
          backgroundColor: '#292C35',
          border: '1px solid #8EABDB !important',
          borderRadius: '4px',
          '&.isOpen': {
            backgroundColor: '#464C64',
          },
          '&:focus-visible': {
            outline: `2px solid #F7F7F7`,
          },
        },

        // EffortPlaning
        '.effortPlaningLeftPanel': {
          borderRight: `1px solid #292C35`,
        },
        '.userCard': {
          borderBottom: `1px solid #292C35`,
          '&.isSelected': {
            backgroundColor: '#292C35',
          },
          background: '#1A1B22',
          '&:hover': {
            background: '#353846',
          },
        },
        '.taskCard': {
          background: '#1A1B22',
          '&:hover': {
            background: '#353846',
          },
        },

        // ActivityCalender
        '.toolbar': {
          '& .button': {
            backgroundColor: '#292C35',
            color: '#F7F7F7',
            '&:hover': {
              backgroundColor: '#353846',
            },
            '& .toolButton': {
              '&.selected': {
                color: '#F7F7F7',
              },
              color: '#464C64',
            },
          },
        },
        '.ReactMuiTableToolbarFilter-inputInput': {
          color: '#FFFFFF',
          '&::placeholder': {
            opacity: 0.7,
            color: '#FFFFFF',
          },
        },
        // DraggableErrorDialog
        '.draggable-error-dialog': {
          '& .dialog-box': {
            backgroundColor: '#FFFFFF',
            border: '1px solid #E0E0E0',
            '& .dialog-title': {
              backgroundColor: '#D32F2F',
              color: '#FFFFFF',
              '& .dialog-title-text': {
                color: '#FFFFFF',
              },
              '& .dialog-close-button': {
                color: '#FFFFFF',
              },
            },
          },
        },
        // Draggable List Item
        'li.draggable-list-item': {
          borderColor: '#555555',
          backgroundColor: '#1A1B22',
          '&:hover': {
            backgroundColor: '#353846',
          },
          '&.is-dragging': {
            borderColor: '#F7F7F7',
            backgroundColor: '#292C35',
          },
          '& .reorder-icon': {
            color: '#CACACA',
          },
        },
        //View Attribute
        '.attributeObj-background': {
          backgroundColor: 'rgba(182, 179, 179, 1)',
        },
        '.attributeObjIcon-background': {
          color: 'rgb(66, 66, 66)',
        },
        // banner
        '.freeze-banner': {
          backgroundColor: '#00BFFF',
          color: '#FFFFFF',
        },
        //FILTER TABS

        '.react-resizable-handle-se::after': {
          borderBottomColor: '#FFFFFF !important',
          borderRightColor: '#FFFFFF !important',
        },
        // LOG
        '.previousValue': {
          backgroundColor: '#FFF2F2',
          color: '#000000',
          borderLeft: '7px solid #F26673',
        },
        '.previousValueHead': {
          color: '#F26673',
        },
        '.modifiedValue': {
          backgroundColor: '#EEFFF5',
          color: '#000000',
          borderLeft: '7px solid #89C99F',
        },
        '.modifiedValueHead': {
          color: '#89C99F',
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          '&.MuiAlert-standard.MuiAlert-colorInfo': {
            backgroundColor: 'rgba(41, 182, 246, 0.12)',
            color: '#E3F2FD',
          },
          '&.MuiAlert-standard.MuiAlert-colorWarning': {
            backgroundColor: '#FDF2E8',
            color: '#78350F',
            '& .MuiAlert-icon': {
              color: '#78350F',
            },
          },
          '& .MuiAlert-icon': {
            color: '#29B6F6',
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#1E2028',
          '&.app-header': {
            boxShadow: 'none',
            borderBottom: '1px solid #2B2E3D',
          },
        },
      },
    },

    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: '#1A1B22',
          '&.ai-autofill-notification': {
            backgroundColor: '#292C35',
          },
          '&.section-card': {
            '&:hover': {
              backgroundColor: '#353846',
            },
            '&.selected-card': {
              backgroundColor: '#353846',
            },
          },
          '&.ai-suggestion-card': {
            backgroundColor: 'transparent',
            borderLeftColor: '#B388FC',
            '&.pending': {
              boxShadow: '0 1px 3px rgba(0, 0, 0, 0.4)',
              '&:hover': {
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.4)',
              },
            },
            '&.accepted': {
              borderLeftColor: '#4CAF50',
              backgroundColor: '#388E3C',
            },
            '&.rejected': {
              borderLeftColor: '#4D4D4D',
              backgroundColor: '#D32F2F',
            },
          },
          '&.activity-block-card': {
            borderColor: '#E4E4E7',
          },
        },
      },
    },
    // divider
    MuiDivider: {
      styleOverrides: {
        root: {
          broderColor: '#292C35',
        },
      },
    },

    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundColor: '#1A1B22',
          boxShadow: '0px 6px 12px rgba(0, 0, 0, 0.31)',
          backgroundImage: 'none',
          borderRadius: '4px',
        },
      },
    },
    MuiBackdrop: {
      styleOverrides: {
        '&.backdrop-blur': {
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: 'rgba(70, 76, 100, 0.5)',
        },
        colorSecondary: {
          borderColor: '#8B96DE',
        },
        root: {
          '&:hover': {
            backgroundColor: '#464C64',
          },
          '&:focus': {
            backgroundColor: '#464C64',
          },
          '&:focus-visible': {
            outlineColor: '#FFFF',
          },
          '&.impacted-chip': {
            backgroundColor: '#EB5757',
            '& .MuiChip-label': {
              color: '#FFFFFF',
            },
          },
          '&.not-impacted-chip': {
            backgroundColor: '#058234',
            '& .MuiChip-label': {
              color: '#FFFFFF',
            },
          },
          '&.file-chip': {
            backgroundColor: '#292C35',
            border: '1px solid',
            borderColor: '#CACACA',
            '&:hover': {
              backgroundColor: 'rgba(70, 76, 100, 0.5)',
            },
            '&.MuiChip-filled': {
              backgroundColor: '#464C64',
              '& .MuiChip-label': {
                color: '#F7F7F7',
              },
              '& .MuiChip-deleteIcon': {
                color: '#F7F7F7',
                '&:hover': {
                  color: '#F7F7F7',
                },
              },
            },
          },
          '&.thread-chip': {
            backgroundColor: 'rgba(70, 76, 100, 0.5)',
            '& .MuiChip-label': {
              color: '#F7F7F7',
            },
          },
          '&.user-chip': {
            backgroundColor: 'transparent !important',
            border: '1px solid',
            borderColor: '#CACACA',
            '& .MuiChip-label': {
              color: '#FFFFFF',
            },
            '& .MuiChip-icon': {
              color: '#CACACA',
            },
          },
          // Update Source Chip Color - used in overview page under other details
          '&.manual-chip': {
            backgroundColor: '#FEF0C7',
            '& .MuiChip-label': {
              color: '#B54708',
            },
          },
          '&.draft-chip': {
            backgroundColor: '#FEF0C7',
            '& .MuiChip-label': {
              color: '#B54708',
            },
          },
          '&.draft-values-count-chip': {
            backgroundColor: '#FEF0C7',
            border: 'none',
            borerRadius: '4px',
            '& .MuiChip-label': {
              color: '#B54708',
            },
            '& .MuiChip-icon': {
              color: '#B54708',
            },
            '&:hover': {
              backgroundColor: '#FEF0C7',
            },
          },
          '&.draft-state-header-chip': {
            backgroundColor: '#FEF0C7',
            border: '0.5px solid #B54708',
            '& .MuiChip-label': {
              color: '#B54708',
            },
            '& .MuiChip-icon': {
              color: '#B54708',
            },
            '&:hover': {
              backgroundColor: '#FFFAEB',
            },
          },
          '&.calculated-chip': {
            backgroundColor: '#D1FADF',
            '& .MuiChip-label': {
              color: '#05603A',
            },
          },
          '&.automation-chip': {
            backgroundColor: '#E4EEFF',
            '& .MuiChip-label': {
              color: '#0C3270',
            },
          },
          '&.default-chip': {
            backgroundColor: '#ECECEC',
            '& .MuiChip-label': {
              color: '#09090B',
            },
          },
          '&.bulk-chip': {
            backgroundColor: '#DBD1FA',
            '& .MuiChip-label': {
              color: '#551EF8',
            },
          },
          '&.overridden-chip': {
            backgroundColor: '#F0CCCF',
            '& .MuiChip-label': {
              color: '#C3000D',
            },
          },
          // advance Chips for headers like "Having" / "Where"
          '&.advance-header-chip': {
            border: '1px solid #BCBCBC',
            backgroundColor: '#252730',
            '& .MuiChip-label': {
              color: '#FFFFFF',
            },
            '&:hover, &:focus, &:active': {
              backgroundColor: '#252730',
              color: '#FFFFFF',
            },
          },
          '&.ai-status-chip': {
            '&.accepted': {
              backgroundColor: 'rgba(76, 175, 80, 0.15)',
              color: '#81C784',
              '& .MuiChip-icon': {
                color: '#81C784',
              },
            },
            '&.rejected': {
              backgroundColor: 'rgba(244, 67, 54, 0.12)',
              color: '#F44336',
              '& .MuiChip-icon': {
                color: '#F44336',
              },
            },
          },
          '&.ai-badge-chip': {
            '&.pending': {
              backgroundColor: '#8E55F9',
              color: '#FFFFFF',
              '& .MuiChip-icon': {
                color: '#FFFFFF',
              },
            },
            '&.accepted': {
              backgroundColor: '#4CAF50',
              color: '#FFFFFF',
              '& .MuiChip-icon': {
                color: '#FFFFFF',
              },
            },
          },
          '&.ai-section-chip': {
            '&.pending': {
              backgroundColor: 'rgba(179, 136, 252, 0.15)',
              '& .MuiChip-label': {
                color: '#B388FC',
              },
            },
            '&.total': {
              backgroundColor: 'rgba(255, 255, 255, 0.08)',
              '& .MuiChip-label': {
                color: 'rgba(255, 255, 255, 0.7)',
              },
            },
          },
          // Landscape ViewAll status chip — dark mode override
          '&.landscape-status-chip': {
            backgroundColor: '#054F31',
            border: '1px solid #32D583',
            '& .MuiChip-label': {
              color: '#6CE9A6',
            },
            '&:hover': {
              backgroundColor: '#054F31',
            },
          },
          '&.MuiChip-colorPrimary > .MuiChip-deleteIcon': {
            color: '#F7F7F7',
            '&:hover': {
              color: '#F7F7F7',
            },
          },
        },
        label: {
          color: '#F7F7F7',
        },
      },
      variants: [
        {
          props: { variant: 'outlined' },
          style: {
            borderColor: '#4D4D4D',
            backgroundColor: '#353846',
            '&:hover': {
              backgroundColor: '#353846',
            },
          },
        },
        {
          props: { variant: 'customFilter' },
          style: {
            borderColor: '#BCBCBC',
            color: '#FFFFFF',
            backgroundColor: 'transparent',
            '&:hover': {
              borderColor: '#BCBCBC',
              backgroundColor: 'transparent',
            },
            '& .MuiChip-deleteIcon': {
              color: '#FFFFFF',
              borderColor: '#FFFFFF',

              '&:hover': {
                color: '#FFFFFF',
                backgroundColor: 'transparent',
              },
            },
          },
        },
      ],
    },

    MuiTableCell: {
      styleOverrides: {
        head: {
          color: '#F9FAFB',
          backgroundColor: '#34363F !important',
          borderBottom: '1px solid #344054',
          '& .FilterIcon svg': {
            color: '#98A2B3 !important',
          },
          '&.list-table-header': {
            backgroundColor: '#34363F !important',
            color: '#F9FAFB !important',
            '& .MuiCheckbox-root': {
              color: '#98A2B3',
            },
            '& .Mui-checked': {
              color: '#F7F7F7',
            },
          },
        },
        sizeMedium: {
          '&.list-table-cell': {
            borderColor: '#CACACA',
          },
        },
        sizeSmall: {
          borderColor: '#CACACA',
          // '&:hover': {
          //   backgroundColor: '#353846',
          // },
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          color: '#FFFFFF',
          borderColor: '#272D55',
          backgroundColor: '#34363F !important',
          '& th': {
            color: 'inherit',
            backgroundColor: 'inherit !important',
          },
          '& .MuiTableSortLabel-root': {
            backgroundColor: 'transparent',
            '& svg': {
              color: '#FFFFFF !important',
              fill: '#FFFFFF !important',
            },
          },
          '&.MuiTableHead-bg th': {
            backgroundColor: '#34363F !important',
            color: '#F9FAFB !important',

            '&:hover': {
              backgroundColor: '#34363F !important',
            },
          },
          borderBottom: 0,
          boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.12)',
        },
      },
    },
    MuiTableSortLabel: {
      styleOverrides: {
        icon: {
          color: '#F7F7F7 !important',
          fill: '#F7F7F7 !important',
        },
      },
    },
    MuiTableBody: {
      styleOverrides: {
        root: {
          borderColor: '#CACACA',
          boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.4)',
          '& .MuiTableRow-root': {
            backgroundColor: '#252730 !important',
            '&:hover': {
              backgroundColor: '#47484E !important',
            },
          },
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:focus-visible': {
            border: `2px solid rgba(247, 247, 247, 0.5)`,
          },
          '&:hover': {
            backgroundColor: '#353846 !important',
          },
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        select: {
          '&:focus-visible': {
            outlineColor: '#FFFF',
          },
        },
        actions: {
          '& button:focus-visible': {
            outlineColor: '#FFFF',
          },
        },
        toolbar: {
          // backgroundColor: '#1A1B22',
        },
      },
    },
    MuiPaginationItem: {
      styleOverrides: {
        previousNext: {
          background: '#3B3B3B !important',
        },
        root: {
          '&:focus-visible': {
            outlineColor: '#FFFF !important',
          },
          '&.Mui-selected': {
            backgroundColor: '#344054 !important',
            color: '#F9FAFB !important',
          },
        },
      },
    },

    MuiLinearProgress: {
      styleOverrides: {
        root: {
          '&.MuiLinearProgress-colorPrimary > .MuiLinearProgress-bar': {
            backgroundColor: '#F7F7F7 !important',
          },
          '&.ai-progress': {
            backgroundColor: 'rgba(179, 136, 252, 0.15)',
            '& .MuiLinearProgress-bar': {
              backgroundColor: '#B388FC',
              transition: 'transform 0.4s ease',
            },
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: '#F7F7F7 !important',
          '&.Mui-focused': {
            color: '#F7F7F7 !important',
          },
          '&.Mui-error': {
            color: '#F44336 !important',
          },
          '&.Mui-disabled': {
            color: 'rgba(255, 255, 255, 0.6) !important',
          },
          '& .MuiInputLabel-asterisk': {
            color: '#F44336 !important',
          },
          '& .MuiFormLabel-asterisk': {
            color: '#F44336 !important',
          },
        },
        asterisk: {
          color: '#F44336 !important',
          '&.Mui-error': {
            color: '#F44336',
          },
        },
      },
    },

    MuiFormControl: {
      styleOverrides: {
        root: {
          '& .MuiInputLabel-root': {
            color: '#F7F7F7',
            '&.Mui-error': {
              color: '#F44336 !important',
            },
            '& .MuiTypography-root': {
              color: '#F7F7F7',
            },
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiInputLabel-root': {
            color: '#F7F7F7',
          },
          '& .MuiInputLabel-shrink': {
            color: '#F7F7F7',
          },
          '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline':
            {
              borderColor: 'rgba(255, 255, 255, 0.8)',
            },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          borderColor: '#CACACA',
          '&.vertical-tabs': {
            borderColor: '#292C35',
          },
          '&.horizontal-tabs-vertical-style': {
            borderColor: '#292C35',
          },
          '&.ai-filter-tabs': {
            borderColor: '#4D4D4D',
          },
        },
        indicator: {
          boxShadow: '0px -2px 14px rgba(0, 0, 0, 0.4)',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          color: 'rgba(255, 255, 255, 0.7)', // Default color for non-selected tabs
          '&:focus-visible': {
            outlineColor: '#FFFF',
          },
          '&.Mui-selected': {
            color: '#F7F7F7', // Color for selected tabs
          },
          '&.vertical-tab-with-icons': {
            color: '#F7F7F7',
            borderColor: '#292C35',
            '&:hover': {
              backgroundColor: '#353846',
            },
            '&.Mui-selected': {
              color: '#F7F7F7',
              backgroundColor: 'rgba(70, 76, 100, 0.5)',
            },
          },
          '&.vertical-tab': {
            color: 'rgba(255, 255, 255, 0.7)',
            borderColor: '#292C35',
            '&:hover': {
              backgroundColor: '#353846',
            },
            '&.Mui-selected': {
              color: '#F7F7F7',
              backgroundColor: 'rgba(70, 76, 100, 0.5)',
            },
          },
          '&.horizontal-tab-vertical-style': {
            color: 'rgba(255, 255, 255, 0.7)',
            borderColor: '#292C35',
            '&:hover': {
              backgroundColor: '#353846',
            },
            '&.Mui-selected': {
              color: 'rgba(255, 255, 255, 0.7)',
              backgroundColor: 'rgba(70, 76, 100, 0.5)',
            },
          },
          '&.ai-filter-tab': {
            color: 'rgba(255, 255, 255, 0.7)',
            borderLeftColor: '#4D4D4D',
            '&:hover': {
              backgroundColor: 'rgba(142, 85, 249, 0.06)',
            },
            '&.Mui-selected': {
              color: '#B388FC',
              borderBottomColor: '#B388FC',
            },
            '&.ai-filter-tab-success.Mui-selected': {
              color: '#4CAF50',
              borderBottomColor: '#4CAF50',
            },
            '&.ai-filter-tab-error.Mui-selected': {
              color: '#F44336',
              borderBottomColor: '#F44336',
            },
          },
          '&.variant-chip-tab': {
            backgroundColor: 'rgba(70, 76, 100, 0.2)',
            color: '#FFFFFF',

            '&:hover': {
              backgroundColor: 'rgba(70, 76, 100, 0.7)',
            },
            '&.Mui-selected': {
              backgroundColor: 'rgba(70, 76, 100, 1)',
            },
          },
          '&.custom-tab': {
            color: '#FFFFFF',
            '&.Mui-selected': {
              background: '#E4EEFF',
              color: '#2F5BBD',
            },
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          '&:focus-visible': {
            outlineColor: '#FFFF',
          },
          '&.Mui-disabled': {
            color: '#BDBDBD',
          },
          '&.Mui-disabled svg *': {
            fill: '#BDBDBD',
          },
          '&.app-header-icon-btn': {
            color: '#C8CADE',
            '&:hover': {
              backgroundColor: '#252838',
              color: '#FFFFFF',
            },
          },
          '&.ai-action-accept': {
            borderColor: '#B388FC',
            color: '#B388FC',
            '&:hover': {
              backgroundColor: '#8E55F9',
              borderColor: '#8E55F9',
              color: '#FFFFFF',
            },
          },
          '&.ai-action-reject': {
            borderColor: '#F44336',
            color: '#F44336',
            '&:hover': {
              backgroundColor: '#F44336',
              color: '#FFFFFF',
            },
          },
          '&.ai-action-undo': {
            borderColor: '#ED6C02',
            color: '#ED6C02',
            '&:hover': {
              backgroundColor: '#ED6C02',
              color: '#FFFFFF',
            },
          },
          '&.ai-action-accept-sm': {
            borderColor: '#B388FC',
            color: '#B388FC',
            '&:hover': {
              backgroundColor: '#8E55F9',
              color: '#FFFFFF',
            },
          },
          '&.ai-action-reject-sm': {
            borderColor: '#F44336',
            color: '#F44336',
            '&:hover': {
              backgroundColor: '#F44336',
              color: '#FFFFFF',
            },
          },
          '&.ai-action-undo-sm': {
            borderColor: '#ED6C02',
            color: '#ED6C02',
            '&:hover': {
              backgroundColor: '#ED6C02',
              color: '#FFFFFF',
            },
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          '&:focus-visible': {
            outlineColor: '#FFFF',
          },
          '&.help-support-pagination-button': {
            border: '1px solid transparent',
            ':hover': {
              border: `1px solid #F7F7F7`,
              boxShadow: 'rgba(0, 0, 0, 0.4) 0px 2px 8px 0px !important',
            },
            boxShadow: 'rgba(0, 0, 0, 0.4) 0px 2px 8px 0px !important',
          },
          '&.Mui-SearchPaginationAction': {
            backgroundColor: '#3D4256',
            color: '#FFFFFF',
            '&:hover': {
              backgroundColor: '#353846',
            },
          },
          '&.automation-lineage-view-button': {
            color: '#8EABDB',
            '&:hover': {
              backgroundColor: 'transparent',
              color: '#8EABDB',
            },
          },
          '&.MenuButtons': {
            color: '#C8CADE',
            '&:hover': {
              backgroundColor: '#252838',
              color: '#FFFFFF',
            },
          },
          '&.filledButton': {
            backgroundColor: '#292C35',
            '&:hover': {
              backgroundColor: '#353846',
            },
            textTransform: 'none',
          },
          '&.ai-upload-button': {
            borderColor: '#B388FC',
            color: '#B388FC',
            '&:hover': {
              borderColor: '#8E55F9',
              backgroundColor: 'rgba(142, 85, 249, 0.1)',
            },
          },
          '&.ai-autofill-trigger-button': {
            borderColor: '#8E55F9',
            color: '#8E55F9',
            '&:hover': {
              borderColor: '#7040D4',
              backgroundColor: 'rgba(142, 85, 249, 0.04)',
            },
          },
          '&.ai-dialog-button': {
            '&.accept': {
              backgroundColor: '#8E55F9',
              color: '#FFFFFF',
              '&:hover': {
                backgroundColor: '#7040D4',
              },
            },
          },
          '&.ai-action-pill': {
            '&.accept': {
              backgroundColor: '#8E55F9',
              color: '#FFFFFF',
              '&:hover': {
                backgroundColor: '#7040D4',
              },
            },
            '&.reject': {
              borderColor: '#F44336',
              color: '#F44336',
              '&:hover': {
                borderColor: '#F44336',
                backgroundColor: 'rgba(244, 67, 54, 0.1)',
              },
            },
            '&.undo': {
              borderColor: '#ED6C02',
              color: '#ED6C02',
              '&:hover': {
                borderColor: '#ED6C02',
                backgroundColor: 'rgba(237, 108, 2, 0.1)',
              },
            },
          },
          '&.log-filter-standalone-btn': {
            borderColor: '#E0E0E0',
            color: '#E0E0E0',
            '&:hover': {
              backgroundColor: '#353846',
              borderColor: '#353846',
              color: '#FFFFFF',
            },
            '&.active': {
              backgroundColor: '#353846',
              borderColor: '#353846',
              color: '#FFFFFF',
            },
          },
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          color: '#F7F7F7',
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: '#F7F7F7',
          '&.Mui-focusVisible': {
            backgroundColor: '#464C64',

            '& .MuiSvgIcon-root': {
              backgroundColor: '#292C35',
            },
          },
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        track: {
          backgroundColor: '#4a4a4a',
          '&.Mui-checked': {
            backgroundColor: '#90caf9 !important',
          },
        },
        thumb: {
          borderColor: '#2a2a2a !important',
          '&.Mui-checked': {
            backgroundColor: '#1a1a1a !important',
          },
        },
        input: {
          '&:focus-visible + .MuiSwitch-thumb': {
            outlineColor: '#FFFF',
          },
        },
      },
    },
    MuiAvatar: {
      styleOverrides: {
        root: {
          // Default avatar styling
          backgroundColor: '#F7F7F7',
          color: '#3B3B3B',
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          backgroundColor: '#1A1B22',
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          borderBottomColor: '#8B96DE',
          '& .MuiListItemIcon-root': {
            color: '#F7F7F7',
          },
          '& .MuiListItemButton-root': {
            '& .list-item-button-hover-actions-right': {
              backgroundImage:
                'linear-gradient(269.82deg, #3D4256 68.25%, rgba(70, 76, 100, 0.1) 87.71%)',
            },
            '&.selected': {
              backgroundColor: '#353846',
            },
            '&:hover': {
              backgroundColor: '#353846',
            },
          },
          '&.explorer-list-item': {
            '&.active': {
              backgroundColor: 'rgba(70, 76, 100, 0.5)',
            },
            '&.inactive': {
              backgroundColor: '#1A1B22',
            },
            '&.isOverAndCanDrop': {
              outline: '1px solid #F7F7F7',
            },
            '&:hover': {
              backgroundColor: 'rgba(70, 76, 100, 0.5)',
            },
          },
        },
      },
    },

    AttributeList: {
      '&.MuiListItemButton-root': {
        padding: '0px',
        '&:hover': {
          backgroundColor: 'none',
        },
      },
      '&.MuiListItem-root': {
        border: '1px solid #D2D2D2',
      },
      styleOverrides: {
        list: { backgroundColor: '#1A1B22 !important' },
        listItem: {
          border: '1px solid #D2D2D2',
          borderRadius: '4px',
        },
      },
    },

    MuiSelect: {
      styleOverrides: {
        select: {
          backgroundColor: '#252730',
        },
        icon: {
          color: '#F7F7F7 !important',
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        asterisk: {
          color: '#F44336 !important',
          '&.Mui-error': {
            color: '#F44336',
          },
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          color: '#F44336',
          '&.Mui-error': {
            color: '#F44336',
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderColor: '#CACACA !important',
          backgroundColor: '#252730 !important',
          '& fieldset': {
            border: 'none',
          },
          '&:hover': {
            borderColor: '#CACACA !important',
          },
          '&.Mui-focused': {
            borderColor: '#F7F7F7 !important',
          },
          '&.Mui-error': {
            borderColor: '#F44336 !important',
            '& .MuiFormHelperText-root': {
              color: '#F44336 !important',
            },
          },
          '&.Mui-disabled': {
            color: 'rgba(255, 255, 255, 0.38) !important',
          },
        },
        input: {
          color: '#FFFFFF !important',
          '&.Mui-disabled': {
            WebkitTextFillColor: 'rgba(255, 255, 255, 0.6)',
            color: 'rgba(255, 255, 255, 0.6)',
          },
          '&::placeholder': {
            color: 'rgba(255, 255, 255, 0.87) !important',
          },
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          backgroundColor: '#252730 !important',
        },
        input: {
          '&:-webkit-autofill': {
            WebkitBoxShadow: '0 0 0 1000px #252730 inset',
            WebkitTextFillColor: '#FFFFFF',
            transition: 'background-color 5000s ease-in-out 0s',
          },
        },
      },
    },
    MuiSlider: {
      styleOverrides: {
        root: {
          color: '#F7F7F7',
        },
        track: {
          backgroundColor: '#F7F7F7',
          borderColor: '#F7F7F7',
        },
        rail: {
          backgroundColor: '#FFFFFF',
          borderColor: '#F7F7F7',
        },
        valueLabel: {
          color: '#3B3B3B',
          background: '#F7F7F7',
        },
        mark: {
          background: '#F7F7F7 !important',
        },
        markLabel: {
          color: '#F7F7F7 !important',
        },
        thumb: {
          '&:hover': {
            boxShadow: `0px 0px 0px 15px ${'rgba(70, 76, 100, 0.5)'} !important`,
          },
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          '&.ai-review-drawer': {
            borderLeft: '1px solid #4D4D4D',
            boxShadow:
              '-4px 0 24px rgba(0, 0, 0, 0.3), -1px 0 6px rgba(0, 0, 0, 0.2)',
          },
          '&.filter-drawer': {
            borderLeft: '1px solid #4D4D4D',
            boxShadow:
              '-4px 0 24px rgba(0, 0, 0, 0.3), -1px 0 6px rgba(0, 0, 0, 0.2)',
          },
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(70, 76, 100, 0.4)',
          '&.permission-accordion': {
            backgroundColor: 'rgba(70, 76, 100, 0.1)',
          },
          '&.log-filter-accordion, &.log-filter-accordion .MuiAccordionDetails-root':
            {
              backgroundColor: 'transparent !important',
            },

          '&:before': {
            backgroundColor: 'transparent !important',
          },
          '&.job-queue-accordion': {
            borderColor: '#CACACA',
            '& .MuiAccordionDetails-root': {
              backgroundColor: 'transparent',
            },
          },
          '&.job-queue-accordion-read': {
            backgroundColor: '#1A1B22',
          },
          '&.job-queue-accordion-unread': {
            backgroundColor: 'rgba(70, 76, 100, 0.2)',
          },
          '&.automation-lineage-details-accordion': {
            backgroundColor: '#1A1B22',
            border: '1px solid #3D4256',
            boxShadow: 'none',
            color: '#FFFFFF',
            '& .MuiAccordionSummary-root': {
              backgroundColor: '#1A1B22',
              borderBottom: '1px solid #3D4256',
            },
          },
          '&.ai-section-accordion': {
            backgroundColor: 'transparent',
            '& .MuiAccordionSummary-root.ai-section-summary': {
              backgroundColor: '#1A1B22F2',
              borderBottomColor: '#4D4D4D',
              borderLeftColor: '#4D4D4D',
              border: `1px solid #E0E0E0`,
              borderRadius: '4px',
              '&:hover': {
                backgroundColor: 'rgba(142, 85, 249, 0.05)',
              },
              '&:focus-visible': {
                outline: '2px solid #B388FC',
                outlineOffset: '-2px',
              },
            },
            '&.has-pending .MuiAccordionSummary-root.ai-section-summary': {
              borderLeftColor: '#B388FC',
            },
          },
          '&.query-dialog-accordion': {
            backgroundColor: '#252730',
            border: '1px solid #3D4256',
            borderRadius: '8px',
            marginBottom: '16px',
            overflow: 'hidden',
            boxShadow: 'none',
            '&:before': {
              display: 'none',
            },
            '& .MuiAccordionSummary-root': {
              backgroundColor: '#252730',
              borderBottom: '1px solid #3D4256',
              height: '36px',
              '& .MuiAccordionSummary-content': {
                margin: 0,
              },
            },
            '& .MuiAccordionSummary-root.Mui-expanded': {
              borderBottom: '1px solid #3D4256',
              height: '36px',
            },
            '& .MuiAccordionDetails-root': {
              padding: '16px 24px 24px',
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
            },
          },
        },
      },
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          backgroundColor: '#1A1B22',
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          background: '#353846',
          color: '#FFFFFF !important',
          '& .MuiTypography-root': {
            color: '#FFFFFF !important',
          },
          '& .landscape-relation-tooltip .MuiTypography-body5': {
            color: '#8A96AB !important',
          },
          '& .landscape-title-card .MuiTypography-body5': {
            color: '#8A96AB !important',
          },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          '&:hover': '#3D4256',
        },
      },
    },
    MuiGrid: {
      styleOverrides: {
        root: {
          '&.summary-card': {
            backgroundColor: '#1A1B22',
            borderRadius: '4px',
          },
        },
      },
    },
    SolyticsEditorToolbar: {
      styleOverrides: {
        baseButton: {
          color: '#FFFFFF',
          backgroundColor: 'transparent',
          ':hover': {
            backgroundColor: 'rgba(70, 76, 100, 0.5)',
          },
          '&.Mui-disabled': {
            color: 'rgba(255, 255, 255, 0.2)',
          },
        },
        toggleButton: {
          color: '#FFFFFF',
          '.MuiTypography-root': {
            color: '#FFFFFF',
          },
          '&.is-active': {
            backgroundColor: 'rgba(70, 76, 100, 0.5)',
            color: '#FFFFFF',
            '.MuiTypography-root': {
              color: '#FFFFFF',
            },
          },
          ':hover': {
            backgroundColor: 'rgba(70, 76, 100, 0.5)',
          },
        },
        headingDropdown: {
          '.MuiSelect-select': {
            backgroundColor: 'transparent',
          },
          '.MuiOutlinedInput-root': {
            backgroundColor: 'transparent',
            ':hover': {
              backgroundColor: 'rgba(70, 76, 100, 0.5)',
            },
          },
        },
        ToolbarPaper: {
          boxShadow: 'rgba(0, 0, 0, 0.4) 0px 2px 8px 0px',
          backgroundColor: '#292C35',
        },
        ToolbarMenu: {
          '.MuiPaper-root': {
            boxShadow: 'rgba(0, 0, 0, 0.4) 0px 2px 8px 0px',
            backgroundColor: '#292C35',
          },
        },
        ToolbarMenuItem: {
          color: '#FFFFFF',
        },
        ToolbarVerticalDivider: {
          backgroundColor: '#CACACA',
        },
      },
    },
    BubbleMenuContainer: {
      styleOverrides: {
        root: {
          backgroundColor: '#292C35',
          boxShadow: 'rgba(0, 0, 0, 0.4) 0px 2px 8px 0px',
        },
      },
    },
    BubbleMenuButton: {
      styleOverrides: {
        root: {
          color: '#FFFFFF',
          backgroundColor: 'transparent',
          ':hover': {
            backgroundColor: 'rgba(70, 76, 100, 0.5)',
          },
        },
      },
    },
    TemplatesSectionsAndAttributes: {
      styleOverrides: {
        section: {
          '&.isOverAndOrdering': {
            borderColor: '#F7F7F7',
          },
          '&.isOrdering': {
            ':hover': {
              borderColor: '#F7F7F7',
            },
          },
        },
      },
    },
    BulkTransitionHistory: {
      styleOverrides: {
        statusCircle: {},
        listItemContainer: {
          '&:hover': {
            background: 'rgba(70, 76, 100, 0.5)',
          },
        },
        itemWrapper: {
          background: 'rgba(70, 76, 100, 0.5)',
        },
        list: {
          bgcolor: '#1A1B22',
        },
        deletedModelBox: {
          '&:hover': {
            background: 'rgba(70, 76, 100, 0.5)',
          },
        },
      },
    },
    WorkflowSidebar: {
      styleOverrides: {
        conditionalCard: {
          backgroundColor: '#292C35',
        },
        conditionalStack: {
          borderColor: '#F7F7F7',
        },
        cardTypography: {
          color: '#F7F7F7',
        },
        nodeCard: {
          borderColor: '#F7F7F7',
          backgroundColor: '#292C35',
        },
        nodeIconBox: {
          backgroundColor: '#292C35',
        },
        nodeContentBox: {
          backgroundColor: '#292C35',
        },
        nodeTypography: {
          color: '#F7F7F7',
        },
      },
    },
    FormulaSidebar: {
      styleOverrides: {
        nodeCard: {
          borderColor: '#F7F7F7',
          backgroundColor: '#292C35',
        },
        container: {
          backgroundColor: '#1A1B22',
          boxShadow: '-4px 0px 4px rgba(0, 0, 0, 0.4)',
        },
        buttonContainer: {
          backgroundColor: '#1A1B22',
        },
        nodesContainer: {
          backgroundColor: '#1A1B22',
        },
      },
    },
    Login: {
      styleOverrides: {
        SuccessAlert: {
          backgroundColor: '#4CAF50',
          color: '#FFFFFF',
        },
        ErrorAlert: {
          backgroundColor: '#F44336',
          color: '#FFFFFF',
        },
      },
    },
    MultiUploadFormDropzoneBox: {
      styleOverrides: {
        root: {
          border: `1px dashed #F7F7F7`,
        },
      },
    },
  },
};

export const darkTheme = DARK_THEME;
export default createTheme(merge(structuredClone(baseTheme), DARK_THEME));
